import React  from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Building2 } from "lucide-react";
import ReactSelect from "react-select";
import SectionHeader from "./SectionHeader";
import DateInputwithcal from "../ui/DateInputwithcal";


function CustomerDetailsSection({
  expandedSections,
  onToggle,
  formData,
  handleInputChange,
  errors,
  inputClass,
  salesOptions,
  setFormData,
  handleDateChange,
  handleDateError,
  carrierList,
  handleAddCarrier,
  handleDeleteCarrier,
  handleCheckDuplicate,
  duplicateCompanies,
  loadingDuplicate,
  showDropdown,
  setShowDropdown,
}) {




  return (
    <>
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800">
        <SectionHeader
          icon={Building2}
          title="Customer Details"
          color="bg-blue-600"
          section="s2"
          toggleSection={onToggle}
          expandedSections={expandedSections}
        />
        {expandedSections.s2 && (
          <div className="p-4 border-t border-slate-200 dark:border-slate-800">
            <div className="grid grid-cols-2 gap-6">
              <div className="grid grid-cols-12 items-center gap-2">
                {/* <span className="text-sm font-medium text-slate-700 dark:text-slate-300"> Office Type: <span className="text-red-500">*</span></label> */}

                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Office Type: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-700 text-slate-800 dark:text-white"
                    name="ddlofficetype"
                    value={formData?.ddlofficetype}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="head_office">Head Office</option>
                    <option value="branch_office">Branch Office</option>
                  </select>
                  {errors.ddlofficetype && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.ddlofficetype}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Identity Type:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlidentityType"
                    value={formData?.ddlidentityType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="PAN">PAN</option>
                    <option value="EIN">EIN</option>
                    <option value="CNPJ">CNPJ (Brazil Company ID)</option>
                    <option value="CPF">CPF (Brazil Person ID)</option>
                    <option value="CUIT">CUIT (Argentina Company ID)</option>
                    <option value="CUIL">CUIL (Argentina Person ID)</option>
                    <option value="RNC">RNC (Dominican Tax ID)</option>
                    <option value="RUC">RUC (Peru &amp; Ecuador Tax ID)</option>
                    <option value="RFC">RFC (Mexico Tax ID)</option>
                    <option value="EORI">EORI (EU Customs ID)</option>
                    <option value="DUN">Dun &amp; Bradstreet Number</option>
                    <option value="PASSPORT">PASSPORT NUMBER</option>
                    <option value="VTAXID">TAXID</option>
                    <option value="USCI">USCI</option>
                    <option value="SSN">SSN (Social Security Number)</option>
                    <option value="BNCC">BN Code(Canada)</option>
                  </select>
                </div>
              </div>

              {/* <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Company Name: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.companyname}
                    onChange={handleInputChange}
                    name="companyname"
                    className={inputClass}
                  />

                  {errors.companyname && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.companyname}
                    </p>
                  )}
                </div>
              </div> */}

<div className="grid grid-cols-12 items-center gap-2">
  <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
    Company Name: <span className="text-red-500">*</span>
  </label>

  {/* INPUT + DROPDOWN WRAPPER */}
  <div className="col-span-10 relative">
    <Input
      type="text"
      value={formData?.companyname}
      onChange={handleInputChange}
      name="companyname"
      className={inputClass}
    />

    {/* ✅ DROPDOWN INSIDE SAME DIV */}
    {showDropdown && duplicateCompanies.length > 0 && (
      <div className="absolute z-50 mt-1 w-full border border-gray-200 dark:border-slate-700 
                      rounded-md max-h-40 overflow-y-auto 
                      bg-white dark:bg-slate-900 shadow-lg">

        {/* Header */}
        <div className="bg-green-600 text-white text-xs font-semibold px-3 py-2 flex justify-between">
          <span>COMPANY NAME</span>
          <button
            type="button"
            onClick={() => setShowDropdown(false)}
            className="text-red-200 hover:text-white"
          >
            ✖
          </button>
        </div>

        {/* List */}
        {duplicateCompanies.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              setFormData((prev) => ({
                ...prev,
                companyname: item.companyName,
                id: item.id,
              }));
              setShowDropdown(false); // ✅ close after select
            }}
            className="px-3 py-2 text-sm cursor-pointer 
                       text-gray-800 dark:text-gray-200
                       hover:bg-gray-100 dark:hover:bg-slate-800
                       border-t border-gray-200 dark:border-slate-700"
          >
            {item.companyName}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* BUTTON */}
  <div className="col-span-2">
    <button
      type="button"
      onClick={handleCheckDuplicate}
      className="w-full bg-green-500 hover:bg-green-600 text-white text-xs py-2 rounded-md"
    >
      {loadingDuplicate ? "Checking..." : "Check Duplicate"}
    </button>
  </div>

  {errors.companyname && (
    <p className="col-span-12 text-red-500 text-xs mt-1">
      {errors.companyname}
    </p>
  )}
</div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Identity No:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.identityno}
                    onChange={handleInputChange}
                    name="identityno"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  EDI Code: <span className="text-red-500"></span>
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.edicode}
                    onChange={handleInputChange}
                    name="edicode"
                    className={inputClass}
                  />
                  {/* {errors.edicode && (
                                                            <p className="text-red-500 text-xs mt-1">{errors.edicode}</p>
                                                            )} */}
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Import Tax ID:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.importtaxid || formData?.fileNumber}
                    onChange={handleInputChange}
                    name="importtaxid"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  FMC:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.fmc}
                    onChange={handleInputChange}
                    name="fmc"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  EORI Number:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.eorinumber}
                    onChange={handleInputChange}
                    name="eorinumber"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  USPPI Contact Name:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.usppicontactname}
                    onChange={handleInputChange}
                    name="usppicontactname"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Scac/IATA Code:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.scaccode}
                    onChange={handleInputChange}
                    name="scaccode"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  USPPI Phone Number:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.usppiphone}
                    onChange={handleInputChange}
                    name="usppiphone"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Insurance Valide Date:
                </label>
                <div className="col-span-12">
                  {/* <Input type="date" value={formData?.insurancevaliddate} onChange={handleInputChange} name="insurancevaliddate" /> */}
                  <DateInputwithcal
                    onError={handleDateError}
                    label="Insurance Valide Date"
                    name="insurancevaliddate"
                    value={formData?.insurancevaliddate}
                    onChange={handleDateChange}
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  USPPI Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.usppiemail}
                    onChange={handleInputChange}
                    name="usppiemail"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Insurance Expire Date:
                </label>
                <div className="col-span-12">
                  {/* <Input type="date" value={formData?.insuranceexpirydate} onChange={handleInputChange} name="insuranceexpirydate" /> */}
                  <DateInputwithcal
                    onError={handleDateError}
                    label="Insurance Expire Date"
                    name="insuranceexpirydate"
                    value={formData?.insuranceexpirydate}
                    onChange={handleDateChange}
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Select Sales Person: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <ReactSelect
                    options={salesOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder="Select Sales Person"
                    value={salesOptions.filter((opt) =>
                      formData.ddlsalesperson.includes(opt.value),
                    )}
                    onChange={(selected) =>
                      setFormData((prev) => ({
                        ...prev,
                        ddlsalesperson: selected.map((s) => s.value),
                      }))
                    }
                    classNames={{
                      control: (state) =>
                        `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                                                                    ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,

                      menu: () =>
                        "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                      option: ({ isFocused, isSelected }) =>
                        `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                                                                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}       text-slate-900 dark:text-white`,

                      multiValue: () =>
                        "bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white",
                      multiValueLabel: () => "text-slate-900 dark:text-white",
                      multiValueRemove: () =>
                        "text-slate-600 dark:text-slate-300 hover:text-red-500",
                    }} // this use for dark and light mode
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Cordinator Phone:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.coordinatorphone}
                    onChange={handleInputChange}
                    name="coordinatorphone"
                    className={inputClass}
                  />
                </div>
              </div>


              

              {/* <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Carrier Contract:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.carriercontract}
                    onChange={handleInputChange}
                    name="carriercontract"
                    className={inputClass}
                  />
                </div>
              </div> */}


{/* LIST BELOW */}

<div className="flex flex-col items-start w-full ">

  {/* INPUT + BUTTON */}
  <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
    Carrier Contract #:
  </label>

  <div className="flex items-center gap-2 w-full">
    
    <input
      type="text"
      name="carriercontract"
      value={formData.carriercontract}
      onChange={handleInputChange}
      className={`${inputClass} flex-1`}
      placeholder="Enter contract"
    />

    <button
      type="button"
      onClick={handleAddCarrier}
      className="w-10 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-lg"
    >
      +
    </button>
  </div>

  {/* LIST */}
  <div className="mt-2 w-full border rounded-md p-2 flex flex-wrap gap-2 max-h-20 overflow-y-auto bg-white dark:bg-slate-900">

    {carrierList.length === 0 && (
      <div className="text-xs text-slate-400">No items added</div>
    )}

    {carrierList.map((item, index) => (
      <div
        key={index}
        className="flex items-center gap-2 px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded-md text-sm"
      >
        <span className="text-slate-700 dark:text-slate-200">
          {item}
        </span>

        <button
          type="button"
          onClick={() => handleDeleteCarrier(index)}
          className="text-red-500 hover:text-red-700 text-xs font-bold"
        >
          ✕
        </button>
      </div>
    ))}
  </div>

</div>





 <div className="grid grid-cols-12 items-center gap-2">
                <label className="mt-8 col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Profit Margin Type:
                </label>
                <div className="col-span-12">
                  <select
                    className="mb-8 w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlprofitmargintype"
                    value={formData?.ddlprofitmargintype}
                    onChange={handleInputChange}
                  >
                    <option value="0">Select</option>
                    <option value="1" selected={true}>
                      LumpSum
                    </option>
                    <option value="2">Percentage</option>
                  </select>
                </div>
              </div>

             

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Coordination Name:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.coordinatname}
                    onChange={handleInputChange}
                    name="coordinatname"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Consignee Type:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlconsigneeType"
                    value={formData?.ddlconsigneeType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="D">DIRECT CONSUMER</option>
                    <option value="G">GOVERNMENT ENTITY</option>
                    <option value="O">OTHER / UNKNOWN</option>
                    <option value="R">RESELLER</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Coordination Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.coordinateemail}
                    onChange={handleInputChange}
                    name="coordinateemail"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Is DPL Active:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-5 h-5"
                    value={formData?.isdplactive}
                    checked={!!formData?.isdplactive}
                    onChange={handleInputChange}
                    name="isdplactive"
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Override DPL:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-5 h-5"
                    value={formData?.overridedpl}
                    checked={!!formData?.overridedpl}
                    onChange={handleInputChange}
                    name="overridedpl"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CustomerDetailsSection;
